<template>
    <div class="video-upload-box g-autofixheight">
        <!-- 上传前 -->
        <div class="video-upload-content" v-show="uploadStatus == 1">
            <div class="video-upload f-align-c">
                <div class="g-upload">
                    <div class="video-check-model" v-if="!ruleCheck" @click="$alert('请确认腾讯游戏玩家创作联盟服务协议')"></div>
                    <label class="upload-button" id="video_btn" for="file-selector">
                        <!-- <img class="upload-image" src="" alt=""> -->
                        <i class="ico ico-upload"></i>
                        <div class="upload-text">点击上传视频</div>
                    </label>
                </div>
            </div>
            <div class="declaration f-align-c">
                <i class="ico-writing" :class="ruleCheck ? 'ico-checkbox-checked' : 'ico-checkbox'" @click="ruleCheck = !ruleCheck"></i>
                <div class="declaration-text" @click.stop="ruleCheck = !ruleCheck">
                    我已阅读并同意遵守
                    <router-link target="_blank" class="protocol" :to="{
                        name: 'v4-notice-detail',
                        params: {
                            id: 9
                        }
                    }">腾讯游戏玩家创作联盟服务协议</router-link>
                </div>
            </div>
            <ul class="tips-group f-clearfix">
                <li class="tip">禁止发布的视频内容
                    <div class="g-tooltip declaration-tips declaration-tips-1">
                        <div class="g-tooltip-arrows-down"></div>
                        <div class="tooltip-content">
                            不得上传未经授权的他人作品，以及色情、反动等违法视频
                        </div>
                    </div>
                </li>
                <li class="tip">视频大小
                    <div class="g-tooltip declaration-tips declaration-tips-2">
                        <div class="g-tooltip-arrows-down"></div>
                        <div class="tooltip-content">
                            最大可上传2G文件
                        </div>
                    </div>
                </li>
                <li class="tip">视频规格
                    <div class="g-tooltip declaration-tips declaration-tips-2">
                        <div class="g-tooltip-arrows-down"></div>
                        <div class="tooltip-content">
                            仅支持MP4格式
                        </div>
                    </div>
                </li>
                <li class="tip">视频时长
                    <div class="g-tooltip declaration-tips declaration-tips-2">
                        <div class="g-tooltip-arrows-down"></div>
                        <div class="tooltip-content">
                            不支持时长小于1秒的视频
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- 视频上传中的状态[[ -->
        <!-- v-loading="loading2"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" -->
        <div class="video-uploading-block" v-show="uploadStatus == 2" v-loading="shacurr"
            element-loading-spinner="el-icon-loading" :element-loading-text="'校验中：'+shacurr+'%'">
            <div class="video-name">{{fileName}}</div>
            <div class="progress-content">
                <div class="progress-bar">
                    <div class="bar" :style="{width: progressBar+'%'}"></div>
                    <div class="progress"></div>
                </div>
                <a href="javascript:;" class="g-btn video-cancel" @click="delVideo()">取消</a>
            </div>
            <div class="progress-tips">
                <span class="tips-name">已上传：</span>
                <span class="tips-content">{{uploadedFileSize}}/{{conver(fileSize)}}</span>
            </div>
            <div class="progress-tips">
                <span class="tips-name">速度：</span>
                <span class="tips-content">{{speed}}/s</span>
            </div>
            <div class="progress-tips">
                <span class="tips-name">剩余时间：</span>
                <span class="tips-content">{{waitTime}}</span>
            </div>
            <!-- <div class="progress-tips" v-show="uploadStatus == 3">
                <span class="tips-name">剩余时间：</span>
                <span class="tips-content">00:00:00</span>
            </div> -->
            <div class="progress-tips">
                <span class="tips-name">进度：</span>
                <span class="tips-content">{{progressBar}}%</span>
            </div>
        </div>
        <!-- 视频上传中的状态 ]] -->

        <!-- 视频上传后的状态 -->
        <div class="video-uploading-block" v-loading="loading" element-loading-spinner="el-icon-loading"
            v-show="uploadStatus == 3">
            <div class="video-name">{{fileName}}</div>
            <video class="f-hide" ref="videoRef" :src="previewUrl" width="200" height="150" controls>
                <!-- <source src="~Assets/img/v1.mp4" type="video/mp4" /> -->
                当前浏览器不支持 video直接播放
            </video>
            <div class="progress-content">
                <div class="progress-bar">
                    <div class="bar" :style="{width: progressBar+'%'}"></div>
                    <div class="progress"></div>
                </div>
                <a href="javascript:;" class="g-btn video-cancel" @click="delVideo()">取消</a>
            </div>
            <div class="progress-tips">
                <span class="tips-name">进度：</span>
                <span class="tips-content">{{progressBar}}%</span>
            </div>
        </div>
        <input id="file-selector" ref="videoInput" class="f-hide" type="file" accept="video/*" @change="addFile($event)">
    </div>
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/contribute.scss';
.video-uploading-block {
    position: relative;
}
.bar {
    transition: linear 0.1s;
}
.video-check-model {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 12;
}
.tip {
    &:after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: -8px;
        width: 4px;
        height: 4px;
        background: #bdbdbd;
        border-radius: 50%;
        margin-top: -2px;
    }
}
</style>
<script>
import videoUploadUgc from 'Mixins/videoUploadUgc';
export default {
    data() {
        return {
            ruleCheck: false
        }
    },
    mixins: [videoUploadUgc]
}
</script>